import * as Yup from 'yup'

export const LoginFormValidationSchema = Yup.object().shape({
  username: Yup.string().required(''),
  password: Yup.string().required(''),
})
